/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('OtherPaymentType_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/otherPaymentTypes/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET'}

        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OtherPaymentType',["OtherPaymentType_Resource","OtherPaymentTypeData", function (OtherPaymentType_Resource,OtherPaymentTypeData)
    {
        var  OtherPaymentType = function (resource)
        {
            this.id = null;
            this.isDeleted = false;
            this.label = null;
            this.order = null;
            this.isUsable = null;
            this.version = null;
            this.loadObject(resource);
            OtherPaymentTypeData.add(this);
        }
        OtherPaymentType.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                this.label = object.label;
                this.order = object.order;
                this.isUsable = object.isUsable;
                if (object.version)
                    this.version = object.version;
            }
        }
        OtherPaymentType.prototype.getObjectResource = function()
        {
            var rsOtherPaymentType = new OtherPaymentType_Resource();
            rsOtherPaymentType.id = this.id;
            rsOtherPaymentType.isDeleted = this.isDeleted;
            rsOtherPaymentType.label = this.label;
            rsOtherPaymentType.order = this.order;
            rsOtherPaymentType.isUsable = this.isUsable;
            return rsOtherPaymentType;
        }

        OtherPaymentType.prototype.getId = function()
        {
            return this.id;
        }

        OtherPaymentType.prototype.setId = function(id)
        {
            this.id = id;
        }

        return OtherPaymentType;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OtherPaymentTypeSrv',["$log","OtherPaymentType_Resource","UserActionData","OtherPaymentType","OtherPaymentTypeData","ServerSrv",
        function ($log,OtherPaymentType_Resource,UserActionData,OtherPaymentType,OtherPaymentTypeData,ServerSrv)
        {
        var  optSrv = {};

        optSrv.query = function(successFunction,errorFunction)
        {
            OtherPaymentType_Resource.query(
                {}, //params
                function (data) {   //success
                    OtherPaymentTypeData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new OtherPaymentType(data[i]);//Auto Add to OtherPaymentTypeData
                    if (successFunction!== undefined)
                        successFunction(OtherPaymentTypeData.indexOtherPaymentTypes);

                },
                function (data) {   //failure
                    $log.error("OtherPaymentType_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        optSrv.save = function(opt,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(optSrv.saveSync, opt, successFunction, errorFunction);
        };
        optSrv.saveSync = function(opt,successFunction,errorFunction)
        {
            //$timeout (function () {

            var OtherPaymentTypeRes = opt.getObjectResource();
            OtherPaymentTypeRes.$save({}, //no params
                function (data) {
                    try{
                        opt.setId(data.id);
                        if (!opt.version || (data.version && data.version > opt.version))
                            opt.version = data.version;
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        optSrv.remove = function(opt,successFunction,errorFunction)
        {
            OtherPaymentTypeData.remove(opt);
            ServerSrv.startSavingProcess(optSrv.removeSync, opt, successFunction, errorFunction);
        };
        optSrv.removeSync =  function(opt,successFunction,errorFunction)
        {
            var optSrv = new OtherPaymentType_Resource();
            optSrv.$remove({id:opt.getId()}, //params : id
                function (data) {
                    try{
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        optSrv.restore = function(opt,successFunction,errorFunction)
        {
            OtherPaymentTypeData.restore(opt);
            ServerSrv.startSavingProcess(optSrv.restoreSync, opt, successFunction, errorFunction);
        };
        optSrv.restoreSync = function(opt,successFunction,errorFunction)
        {
            //$timeout (function () {

            var OtherPaymentTypeRes = opt.getObjectResource();
            OtherPaymentTypeRes.$save({}, //no params
                function (data) {
                    try{
                        opt.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        optSrv.get =  function(id,successFunction,errorFunction)
        {
            OtherPaymentType_Resource.get(
                {id:id}, //params
                function (optResource) {
                    if (successFunction!=undefined)
                        successFunction(new OtherPaymentType(optResource));
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };

        optSrv.updateLocally =  function(id,resource)
        {
            var opt =  OtherPaymentTypeData.getById(id)
            if (opt!=null)
                opt.loadObject(resource);
            return opt;
        };
        optSrv.removeLocally =  function(id,resource)
        {
            var opt =  OtherPaymentTypeData.getById(id)
            if (opt!=null)
                OtherPaymentTypeData.remove(opt);
            return opt;
        };
        optSrv.addLocally =  function(id,resource)
        {
            var opt =  OtherPaymentTypeData.getById(id);
            if (opt!=null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                opt.loadObject(resource);
                OtherPaymentTypeData.add(opt);
            }
            else
            {
                opt = new OtherPaymentType(resource);
                opt.id = id;
            }
            return opt;
        };

        return optSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OtherPaymentTypeData',["$filter", function ($filter)
    {
        var  optDataSrv =
        {
            indexOtherPaymentTypes : [],
            activeOtherPaymentTypes : [],
            deletedOtherPaymentTypes : []//deleted items
        };
        optDataSrv.getById =  function(optId)
        {
            for (var i=0;i<this.indexOtherPaymentTypes.length;i++)
                if (this.indexOtherPaymentTypes[i].getId()==optId)
                    return this.indexOtherPaymentTypes[i];
            return null;
        }
        optDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexOtherPaymentTypes.length)
                return this.indexOtherPaymentTypes[index];
            return null;
        }
        optDataSrv.getIndexOf =  function(opt)
        {
            if (opt)
                return this.indexOtherPaymentTypes.indexOf(opt);
            return -1;
        }

        optDataSrv.add =  function(opt)
        {
            var optArray = this.activeOtherPaymentTypes;
            if (opt.isDeleted)
                optArray =  this.deletedOtherPaymentTypes;
            var index =  this.indexOtherPaymentTypes.indexOf(opt);
            if (index!=-1)
            {
                var realIndex = optArray.indexOf(opt);
                if (realIndex==-1)
                    optArray.push(opt);
            }
            else
            {
                index = this.indexOtherPaymentTypes.length
                this.indexOtherPaymentTypes.push(opt);
                optArray.push(opt);
            }
            return index;
        }        
        optDataSrv.remove =  function(opt)
        {
            var index =  this.activeOtherPaymentTypes.indexOf(opt);
            if (index!=-1)
            {
                this.activeOtherPaymentTypes.splice(index, 1);
                this.deletedOtherPaymentTypes.push(opt);
                opt.isDeleted=true;
            }
        }
        optDataSrv.restore =  function(opt)
        {
            var index =  this.deletedOtherPaymentTypes.indexOf(opt);
            if (index!=-1)
            {
                this.deletedOtherPaymentTypes.splice(index, 1);
                this.activeOtherPaymentTypes.push(opt);
                opt.isDeleted=false;
            }
        }
        optDataSrv.clear =  function()
        {
            this.indexOtherPaymentTypes = [];
            this.activeOtherPaymentTypes = [];
            this.deletedOtherPaymentTypes = [];
        }
        optDataSrv.sort =  function()
        {
            this.activeOtherPaymentTypes = $filter('orderBy')(this.activeOtherPaymentTypes,'order', false);
            this.deletedOtherPaymentTypes = $filter('orderBy')(this.deletedOtherPaymentTypes,'order', false);
        }

        optDataSrv.getActiveList =  function()
        {
            return this.activeOtherPaymentTypes;
        }
        optDataSrv.getDeletedList =  function()
        {
            return this.deletedOtherPaymentTypes;
        }
        return   optDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/OtherPaymentType.js